<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('xtgl')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('edgl')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="searchleft">
                        <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                            <el-form-item :label="$t('type')">
                                <el-select size="small" v-model="searchform.type" style="width:180px;" :placeholder="$t('qxztype')"  >
                                    <el-option :label="$t('buxian')" :value="null"></el-option>
                                    <el-option :label="$t('tegz')" :value="1"></el-option>
                                    <el-option :label="$t('jegz')" :value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="searchright">
                        <el-button size="small" type="primary" @click="openadd">+{{$t('added')}}</el-button>
                    </div>
                    <el-table :data="list" :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="type" :label="$t('type')">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.type==1" type="primary" size="mini">{{$t('tegz')}}</el-tag>
                                <el-tag v-if="scope.row.type==2" type="primary" size="mini">{{$t('jegz')}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="number" :label="$t('jkcs')"></el-table-column>
                        <el-table-column prop="overdueNumType" :label="$t('yqcstype')">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.overdueNumType==1" type="primary" size="mini">{{$t('v1')}}</el-tag>
                                <el-tag v-if="scope.row.overdueNumType==2" type="primary" size="mini">{{$t('v2')}}</el-tag>
                                <el-tag v-if="scope.row.overdueNumType==3" type="primary" size="mini">{{$t('v3')}}</el-tag>
                                <el-tag v-if="scope.row.overdueNumType==4" type="primary" size="mini">{{$t('v4')}}</el-tag>
                                <el-tag v-if="scope.row.overdueNumType==5" type="primary" size="mini">{{$t('v5')}}</el-tag>
                                <el-tag v-if="scope.row.overdueNumType==6" type="primary" size="mini">{{$t('v6')}}</el-tag>
                                <el-tag v-if="scope.row.overdueNumType==7" type="primary" size="mini">{{$t('v7')}}</el-tag>
                                <el-tag v-if="scope.row.overdueNumType==8" type="primary" size="mini">{{$t('v8')}}</el-tag>
                                <el-tag v-if="scope.row.overdueNumType==9" type="primary" size="mini">{{$t('v9')}}</el-tag>
                                <el-tag v-if="scope.row.overdueNumType==10" type="primary" size="mini">{{$t('v10')}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="overdueNum" :label="$t('yqcs')"></el-table-column>
                        <el-table-column prop="overdueDaysType" :label="$t('zhycjktype')">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.overdueNumType==1" type="primary" size="mini">{{$t('v1')}}</el-tag>
                                <el-tag v-if="scope.row.overdueNumType==2" type="primary" size="mini">{{$t('v2')}}</el-tag>
                                <el-tag v-if="scope.row.overdueNumType==3" type="primary" size="mini">{{$t('v3')}}</el-tag>
                                <el-tag v-if="scope.row.overdueNumType==4" type="primary" size="mini">{{$t('v4')}}</el-tag>
                                <el-tag v-if="scope.row.overdueNumType==5" type="primary" size="mini">{{$t('v5')}}</el-tag>
                                <el-tag v-if="scope.row.overdueNumType==6" type="primary" size="mini">{{$t('v6')}}</el-tag>
                                <el-tag v-if="scope.row.overdueNumType==7" type="primary" size="mini">{{$t('v7')}}</el-tag>
                                <el-tag v-if="scope.row.overdueNumType==8" type="primary" size="mini">{{$t('v8')}}</el-tag>
                                <el-tag v-if="scope.row.overdueNumType==9" type="primary" size="mini">{{$t('v9')}}</el-tag>
                                <el-tag v-if="scope.row.overdueNumType==10" type="primary" size="mini">{{$t('v10')}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="overdueDays" :label="$t('zhycjkts')"></el-table-column>
                        <el-table-column prop="quota" :label="$t('dzed')"></el-table-column>
                        <el-table-column prop="platform" :label="$t('pingt')"></el-table-column>
                        <el-table-column prop="jobName" :label="$t('operator')" width="150">
                            <template slot-scope="scope">
                                <el-button size="small" @click="openedit(scope.row)" type="primary" icon="el-icon-edit"
                                    circle plain style="margin-right:5px;"></el-button>
                                <el-popconfirm :title="$t('isDel')" @confirm="deleteproduct(scope.row)">
                                    <el-button size="small" type="warning" icon="el-icon-delete-solid" circle slot="reference" plain></el-button>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <pop-up :title="status == 1 ? $t('added') : $t('edited')" :isshow="showadd" :haveconfirm="true" @close="getclose" @confirm="getconfirm">
            <div slot="box">
                <el-form ref="form" :inline="true" :model="form" :rules="rules" size="small" label-width="330px">
                    <el-form-item :label="$t('type')">
                        <el-select size="small" v-model="form.type" style="width:240px;" :placeholder="$t('qxzyqlx')"  >
                            <el-option :label="$t('tegz')" :value="1"></el-option>
                            <el-option :label="$t('jegz')" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('jkcs')">
                        <el-input v-model="form.number" />
                    </el-form-item>
                    <el-form-item :label="$t('yqcstype')">
                        <el-select size="small" v-model="form.overdueNumType" style="width:240px;" :placeholder="$t('qxzyqcslx')"  >
                            <el-option :label="$t('v1')" :value="1"></el-option>
                            <el-option :label="$t('v2')" :value="2"></el-option>
                            <el-option :label="$t('v3')" :value="3"></el-option>
                            <el-option :label="$t('v4')" :value="4"></el-option>
                            <el-option :label="$t('v5')" :value="5"></el-option>
                            <el-option :label="$t('v6')" :value="6"></el-option>
                            <el-option :label="$t('v7')" :value="7"></el-option>
                            <el-option :label="$t('v8')" :value="8"></el-option>
                            <el-option :label="$t('v9')" :value="9"></el-option>
                            <el-option :label="$t('v10')" :value="10"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('yqcs')">
                        <el-input v-model="form.overdueNum" />
                    </el-form-item>
                    <el-form-item :label="$t('zhycjktype')">
                        <el-select size="small" v-model="form.overdueDaysType" style="width:240px;" :placeholder="$t('qxzzhycjktslx')"  >
                            <el-option :label="$t('v1')" :value="1"></el-option>
                            <el-option :label="$t('v2')" :value="2"></el-option>
                            <el-option :label="$t('v3')" :value="3"></el-option>
                            <el-option :label="$t('v4')" :value="4"></el-option>
                            <el-option :label="$t('v5')" :value="5"></el-option>
                            <el-option :label="$t('v6')" :value="6"></el-option>
                            <el-option :label="$t('v7')" :value="7"></el-option>
                            <el-option :label="$t('v8')" :value="8"></el-option>
                            <el-option :label="$t('v9')" :value="9"></el-option>
                            <el-option :label="$t('v10')" :value="10"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('zhycjkts')">
                        <el-input v-model="form.overdueDays" />
                    </el-form-item>
                    <el-form-item :label="$t('dzed')">
                        <el-input v-model="form.quota" />
                    </el-form-item>
                    <el-form-item :label="$t('pingt')">
                        <el-input v-model="form.platform" />
                    </el-form-item>
                    <el-form-item label="国家" >
                        <el-select v-model="form.nation" placeholder="请选择国家">
                            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </pop-up>
    </div>
</template>
<script>
    import apiurl from "@/api/sys"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                options: [{
                        value: 'mx',
                        label: '墨西哥'
                        }, {
                        value: 'pe',
                        label: '秘鲁'
                    }],
                form: {
                    id: null,
                    type: null,
                    number: null,
                    overdueNumType: null,
                    overdueNum: null,
                    overdueDaysType: null,
                    overdueDays: null,
                    platform:null,
                    nation:null,
                    quota: null
                },
                searchform: {
                    type: "",
                },
                defaultProps: {
                    label: "name",
                    isLeaf: 'isLeaf'
                },
                loading: false,
                showadd: false,
                searchform:{},
                list: [],
                value1:[],
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.getList()
        },
        methods: {
            openadd() {
                this.showadd = true
                this.status = 1
                this.form = {
                    id: null,
                    type: null,
                    number: null,
                    overdueNumType: null,
                    overdueNum: null,
                    overdueDaysType: null,
                    overdueDays: null,
                    platform:null,
                    nation:null,
                    quota: null
                }
            },
            openedit(row) {
                this.status = 2
                this.form.id = row.id
                this.form.type = row.type
                this.form.number = row.number
                this.form.overdueNumType = row.overdueNumType
                this.form.overdueNum = row.overdueNum
                this.form.overdueDaysType = row.overdueDaysType
                this.form.overdueDays = row.overdueDays
                this.form.quota = row.quota
                this.form.nation = row.nation
                this.form.platform = row.platform
                this.showadd = true
            },
            getclose() {
                this.$refs.form.resetFields();
                this.showadd = false
            },
            handleNodeClick(mydata, node, obj) {
                this.loading = true
                this.getList()
            },
            deleteproduct(row) {
                _api.delete(apiurl.limit, row.id).then(res => {
                    this.$notify({
                        title: this.$t('success'),
                        message: this.$t('delSuccess'),
                        type: 'success'
                    });
                    this.getList()

                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    });
                })
            },
            getconfirm() {
                if (this.status == 1) { //如果是添加
                    _api.post(apiurl.limit, this.form).then(res => {
                        this.$notify.success({
                            title: this.$t('success'),
                            message: this.$t('addSuccess'),
                        })
                        this.getList()
                        this.showadd = false
                        this.form = {
                            id: null,
                            type: null,
                            number: null,
                            overdueNumType: null,
                            overdueNum: null,
                            overdueDaysType: null,
                            overdueDays: null,
                            platform:null,
                            nation:null,
                            quota: null
                        }

                    }).catch(err => {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: err.data.message
                        })
                    })
                } else { //如果是编辑
                    _api.put(apiurl.limit, this.form).then(res => {
                        this.$notify.success({
                            title: this.$t('success'),
                            message: this.$t('editSuccess'),
                        })
                        this.getList()
                        this.showadd = false
                        this.form = {
                            id: null,
                            type: null,
                            number: null,
                            overdueNumType: null,
                            overdueNum: null,
                            overdueDaysType: null,
                            overdueDays: null,
                            platform:null,
                            nation:null,
                            quota: null
                        }
                    }).catch(err => {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: err.data.message
                        })
                    })
                }
                  
            },
            getList() {
                this.loading = true
                _api.get(apiurl.limit, {
                    type: this.searchform.type,
                    platform: this.searchform.platform,
                    nation:localStorage.getItem("nation"),
                }).then(res => {
                    this.loading = false
                    this.list = res.data
                })
            },
            onSubmit() {
                this.getList()
            },
            
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .top {
        margin-top: 15px;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>